module.exports = __webpack_public_path__ + "static/media/product_category_27.185fb455.png";